module.exports = __webpack_public_path__ + "img/seal1.558f1b5f.png";